/**
 * @title add-additional-people.js: Sub-module for Add Additional People Outside Renewal page
 * @description This module is used to handle adding additional people outside renewal.
 * @dependency
 * Global variables from AddAdditionalPeople_Data.jsp:
 * var membershipData
 * var membershipType
 * var checkoutPage
 * var newlyAddedAffiliatesTotal 
 */
define(['applicationAffiliateForm'], function(affForm) {
  
  let AddAdditionalPeople = {

    /**
     * Basic initial function. 
     */
    init: function() {
      this.membershipData = membershipData;
      if (newlyAddedAffiliatesTotal > 0) {
          this.displayInfoMessageInNotification();
      }
      console.log('AddAdditionalPeople module initialized.');
    },

    /**
     * Displays info-message for this page as success notification.
     */
    displayInfoMessageInNotification: function() {
      if (! $('#notification-message').hasClass('critical-notification')) {
    	  COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
      }
    },

    /**
     * Remove a newly added affiliate.
     * @param {number} affiliateMembershipNumber The affiliate's membership number.
     */
    removePerson: function(affiliateMembershipNumber) {
      let affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
      // This is necessary because affForm.removePerson is expecting an object
      // thats tied to how the membership application "configProduct" represents
      // that affiliate, this will normalize that.
      affiliate = {
        membershipNumber: affiliate.cardNumber.value,
        firstName: affiliate.firstName.value,
        lastName: affiliate.lastName.value,
        newCreated: true, 
        houseHold: (affiliate.household && affiliate.household.cardNumber.value) ? {
          membershipNumber: affiliate.household.cardNumber.value,
          firstName: affiliate.household.firstName.value,
          lastName: affiliate.household.lastName.value,
        } : undefined,
      };
      affForm.removePerson({
        affiliate: affiliate,
        isOutsideRenewal: true,
        excludeData: true,
        action: 'remove-affiliate',
      });
    },

    /**
     * Add an affiliate.
     */
    addPerson: function() {
      affForm.openAddPersonModal({
        isOutsideRenewal: true,
      });
    },

    /**
     * Add a person within household to affiliate.
     * @param {number} membershipNumber The affiliate's membership number.
     */
    addPersonWithinHousehold: function(membershipNumber) {
      let affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
        addHousehold: true,
        isOutsideRenewal: true,
      });
    },

    /**
     * The interface to remove an affiliate's household.
     * @param {number} affiliateMembershipNumber The affiliate's membership number.
     */
    removePersonHousehold: function(affiliateMembershipNumber) {
      let affiliate = COSTCO.MembershipHelper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
      // This is necessary because affForm.removePerson is expecting an object
      // thats tied to how the membership application "configProduct" represents
      // that affiliate, this will normalize that.
      affiliate = {
        membershipNumber: affiliate.cardNumber.value,
        firstName: affiliate.firstName.value,
        lastName: affiliate.lastName.value,
        newCreated: false, 
        houseHold: {
          membershipNumber: affiliate.household.cardNumber.value,
          firstName: affiliate.household.firstName.value,
          lastName: affiliate.household.lastName.value,
        },
      };
      affForm.removePerson({
        affiliate: affiliate,
        isOutsideRenewal: true,
        excludeData: true,
        action: 'remove-household',
      });
    },
  };
  
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  
  window.COSTCO.AddAdditionalPeople = AddAdditionalPeople;
  
  return AddAdditionalPeople;
});



// WEBPACK FOOTER //
// ./js/account/add-additional-people.js